module.exports = __webpack_public_path__ + "image/serve-banner.jpg";